import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { NotifyHelper } from "../../../helpers/toast";
import { keHoachMonApi } from "../../../api/ke-hoach/keHoachMonApi";
import { lopTinChiApi } from "../../../api/lop-tin-chi/lopTinChiApi";
import { IKeHoachMonToanKhoaSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonToanKhoaSelectRequest";
import { eKeHoachToanKhoaActionIds, IKeHoachToanKhoaActionTypes } from "../../action-types/ke-hoach/IKeHoachToanKhoaActions";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { IKeHoachMonAddRequest } from "../../../model/request/ke-hoach/IKeHoachMonAddRequest";
import { IKeHoachToanKhoaReducer } from "../../reducer-model/ke-hoach/IKeHoachToanKhoaReducer";

export function* keHoachMonToanKhoaSaga(): any {
    yield takeLatest(eKeHoachToanKhoaActionIds.LOAD_START, loadWorker);
    yield takeEvery(eKeHoachToanKhoaActionIds.UPDATE_START, updateWorker);
    yield takeEvery(eKeHoachToanKhoaActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eKeHoachToanKhoaActionIds.ADDING_MONHOC_START, addingMonHocWorker);
    yield takeEvery(eKeHoachToanKhoaActionIds.CREATE_LOP_TC_AUTO_START, createLopTcAutoWorker);
}

function* loadWorker(action: IKeHoachToanKhoaActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.SelectToanKhoa, action.payload as IKeHoachMonToanKhoaSelectRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachToanKhoa.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.keHoach.keHoachToanKhoa.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* updateWorker(action: IKeHoachToanKhoaActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.UpdateMonHoc, action.payload as IKeHoachMonViewModel[]);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachToanKhoa.UPDATE_SUCCESS(res.data));
    } else {
        yield put(rootActions.keHoach.keHoachToanKhoa.UPDATE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: IKeHoachToanKhoaActionTypes): any {
    const ids = action.payload as number[]
    const res: IBaseRespone = yield call(keHoachMonApi.Deletes, { ids });
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachToanKhoa.DELETE_SUCCESS(res.data));
    } else {
        yield put(rootActions.keHoach.keHoachToanKhoa.DELETE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* addingMonHocWorker(action: IKeHoachToanKhoaActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.AddMonHoc, action.payload as IKeHoachMonAddRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachToanKhoa.ADDING_MONHOC_SUCCESS(res.data));
    } else {
        yield put(rootActions.keHoach.keHoachToanKhoa.ADDING_MONHOC_ERRR(res.message ?? "Có lỗi"));
    }
}

function* createLopTcAutoWorker(action: IKeHoachToanKhoaActionTypes): any {
    const state: IKeHoachToanKhoaReducer = yield select((s: any) => s.keHoach.keHoachToanKhoa);
    const { filter, selectionIds } = state;
    const ky_dang_ky = action.payload as number;
    const res: IBaseRespone = yield call(lopTinChiApi.IniByKeHoachToanKhoa, {
        id_he: filter.id_he,
        khoa_hoc: filter.khoa_hoc,
        id_chuyen_nganh: filter.id_chuyen_nganh,
        id_kh_mons: selectionIds,
        ky_dang_ky,
    });
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachToanKhoa.CREATE_LOP_TC_AUTO_SUCCESS(undefined));
    } else {
        yield put(rootActions.keHoach.keHoachToanKhoa.CREATE_LOP_TC_AUTO_ERROR(res.message ?? "Có lỗi"));
    }
}